var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2149_2003)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63 7.03992L9.02 2.83992C10.37 1.78992 12.62 1.73992 14.02 2.71992L20.2 7.04992C21.19 7.73992 22 9.28992 22 10.4999V17.7799C22 20.0899 20.11 21.9899 17.79 21.9899H6.21C3.89 21.9899 2 20.0899 2 17.7699V10.3599C2 9.22992 2.73 7.73992 3.63 7.03992ZM12.75 14.9899C12.75 14.5757 12.4142 14.2399 12 14.2399C11.5858 14.2399 11.25 14.5757 11.25 14.9899V17.9899C11.25 18.4041 11.5858 18.7399 12 18.7399C12.4142 18.7399 12.75 18.4041 12.75 17.9899V14.9899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63 7.03992L9.02 2.83992C10.37 1.78992 12.62 1.73992 14.02 2.71992L20.2 7.04992C21.19 7.73992 22 9.28992 22 10.4999V17.7799C22 20.0899 20.11 21.9899 17.79 21.9899H6.21C3.89 21.9899 2 20.0899 2 17.7699V10.3599C2 9.22992 2.73 7.73992 3.63 7.03992ZM12.75 14.9899C12.75 14.5757 12.4142 14.2399 12 14.2399C11.5858 14.2399 11.25 14.5757 11.25 14.9899V17.9899C11.25 18.4041 11.5858 18.7399 12 18.7399C12.4142 18.7399 12.75 18.4041 12.75 17.9899V14.9899Z",
    fill: "url(#paint0_linear_2149_2003)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63 7.03992L9.02 2.83992C10.37 1.78992 12.62 1.73992 14.02 2.71992L20.2 7.04992C21.19 7.73992 22 9.28992 22 10.4999V17.7799C22 20.0899 20.11 21.9899 17.79 21.9899H6.21C3.89 21.9899 2 20.0899 2 17.7699V10.3599C2 9.22992 2.73 7.73992 3.63 7.03992ZM12.75 14.9899C12.75 14.5757 12.4142 14.2399 12 14.2399C11.5858 14.2399 11.25 14.5757 11.25 14.9899V17.9899C11.25 18.4041 11.5858 18.7399 12 18.7399C12.4142 18.7399 12.75 18.4041 12.75 17.9899V14.9899Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.5,
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2149_2003",
    x: 0,
    y: 0,
    width: 25,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.979085 0 0 0 0 0.979085 0 0 0 0 0.979085 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2149_2003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2149_2003",
    x1: 10.4507,
    y1: 17.2679,
    x2: 17.0793,
    y2: 6.81884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A61FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#F237BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FA8EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC4A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.1f72d82547ed197f8c8f9579f8e414b5.svg";
export { ForwardRef as ReactComponent };